import { CardImage } from '@blueprint/card';
import { Image } from '../graphql.generated';
import { ImagePlaceholder } from '@zoopla/assets';
import getListingImage from './getListingImage';
import {
    CardImagePlaceholder,
    ListingImageCount,
    PropertyImage,
    BadgeContainer
} from './ListingImage.styles';
import { CameraMinifillSmall } from '@blueprint/icons';
import { getBadgePropsForText } from '@zoopla/listing-badges';
import { Badge } from '@zoopla-eng/zds-components/badges';

type ListingImageProps = {
    count?: number | null | undefined;
    image?: Image | null | undefined;
    useImagePlaceholder?: boolean;
    badgeText?: string | null | undefined;
    sizes?: string;
    useImageLazyLoad?: boolean;
};

const ListingImage = ({
    count,
    image,
    useImagePlaceholder = true,
    badgeText,
    sizes = '17.5rem',
    useImageLazyLoad = false
}: ListingImageProps) => {
    const listingImage = getListingImage(image);
    const hasImage = Boolean(listingImage.src);
    const badgeProps = badgeText ? getBadgePropsForText(badgeText) : null;

    return (
        <PropertyImage data-name="property-image">
            {badgeProps ? (
                <BadgeContainer>
                    <Badge {...badgeProps} />
                </BadgeContainer>
            ) : null}

            {hasImage && (
                <>
                    <CardImage
                        sizes={sizes}
                        src={listingImage.src}
                        responsiveImgList={listingImage.responsiveImgList}
                        alt={`Listing${
                            listingImage.alt ? ` - ${listingImage.alt}` : ''
                        }`}
                        data-testid="property-img"
                        lazy={useImageLazyLoad}
                        loading={useImageLazyLoad ? 'lazy' : undefined}
                    />
                    {count && (
                        <ListingImageCount>
                            <CameraMinifillSmall />
                            {count}
                        </ListingImageCount>
                    )}
                </>
            )}

            {!hasImage && useImagePlaceholder && (
                <CardImagePlaceholder>
                    <img
                        width="90"
                        src={ImagePlaceholder}
                        role="presentation"
                        data-testid="property-img-placeholder"
                        loading="lazy"
                        alt=""
                    />
                </CardImagePlaceholder>
            )}
        </PropertyImage>
    );
};

export default ListingImage;
export { PropertyImage, CardImagePlaceholder };
